import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class BillService {

  constructor(private http: HttpClient) { }

  saveBill(id: any, payload: any) {
    if (id) {
      return this.http.put(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILLS + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }

    return this.http.post(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILLS, payload)
      .pipe(catchError(errorHandl));
  }

  getBills(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILLS, { params })
      .pipe(catchError(errorHandl));
  }

  deleteBill(id: any) {
    return this.http.delete(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILLS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  sendBill(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILLS + `/${id}/send`)
      .pipe(catchError(errorHandl));
  }

  getBillById(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILLS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  syncBill(billId: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILLS + `/${billId}/${urls.SYNC}`, { params })
      .pipe(catchError(errorHandl));
  }
}
